import type { FunctionComponent } from 'react'
import React from 'react'
import { Grid, GridItem } from '@which/seatbelt'

import classnames from 'classnames'

import { SubVerticalHeader } from '../../../../components/SubVerticalHeader'

export const FullWidthSubVerticalHeader: FunctionComponent<Props> = ({
  backgroundColour,
  ...props
}) => (
  <div
    className={classnames(backgroundColour && `sb-bg-color-${backgroundColour}`)}
    data-testid="full-width-sub-vertical-header"
  >
    <Grid>
      <GridItem span={{ medium: 8, large: 8 }} columnStart={{ medium: 3, large: 3 }}>
        <SubVerticalHeader {...props} />
      </GridItem>
    </Grid>
  </div>
)

type Props = Parameters<typeof SubVerticalHeader>[0] & {
  backgroundColour?: string
}
